<template>
    <div class="stepOneRoot">
      <div class="circleItem"><CircleVue currentIndex="1"></CircleVue> </div>
      <div class="backPageItem"><BackPageVue  @backPreviewPage="hanldGoBack"></BackPageVue> </div>
       
      <div class="titleLine">What’s Your Top Priority Right Now?</div>
      <div class="chooseBlock">
          <div class="chooseItem" v-for="(item, index) in radiaObj" :key="index">
              <el-radio v-model="chooseRadio"  :label="item.value" border>{{item.name}}</el-radio>
          </div>
      </div>
      <div class="btnLine">
          <div class="disBtn" v-if="chooseRadio==-1">Next</div>
          <div class="chooseBtn" v-else @click="goToNextStep">Next</div>
      </div>
      <div class="LastLine">
          <div class="skipBtn" @click="goToNextStep">Skip</div>
      </div>
      <div class="LastLine2">
          <div class="oneItem">© 2025 PaperSpotlight. All rights reserved.</div>
          <!-- <div class="twoItem">The data presented is based on our independent research and analysis. While we strive for accuracy, results may vary across different fields and contexts. Unauthorized reproduction or distribution of this content is prohibited.</div> -->
      </div>
    </div>
</template>
<script>
import CircleVue from './circle.vue'
import BackPageVue from './backPage.vue'
export default {
    components:{CircleVue,BackPageVue},
    data(){
      return{
        imgObj:{
          guideHomebg1:require("../../assets/img/main/guideHomebg1.png"),
          guideHomebg2:require("../../assets/img/main/guideHomebg2.png"),
        },
        chooseRadio: -1,
        radiaObj:[
          {name:`Enhance profile for EB1`,value:1},
          {name:`Enhance profile for EB2/NIW`,value:2},
          {name:`Reach top 1% Most-Cited Paper (Web of Science)`,value:3},
          {name:`Increase your H-index`,value:4},
          {name:`Gain visibility to attract more academic & career opportunities`,value:5},
          {name:`Others`,value:6},
        ]

      }
  },
  mounted: function() {
    let userData = JSON.parse(localStorage.getItem('userData'))
    if(userData&&userData.stepOne){
      this.chooseRadio = userData&&userData.stepOne

    }
  },
  methods:{
    hanldGoBack(){
      console.log('234')
      localStorage.setItem('guideIndex', 0);
      this.$emit('changePage', 0);
    },
    goToNextStep(){
          console.log('chooseRadio',this.chooseRadio)
          localStorage.setItem('guideIndex', 2);

          let userData = JSON.parse(localStorage.getItem('userData'))||{}
          if(this.chooseRadio>-1){
            userData.stepOne = this.chooseRadio
            let str = JSON.stringify( userData)
            localStorage.setItem('userData', str);
          }else{
            userData.stepOne = ''
            let str = JSON.stringify( userData)
            localStorage.setItem('userData', str);
          }
          this.$emit('changePage', 2);
      }
  }
}
</script>

<style lang="scss">
.stepOneRoot{
    width: 100%;
    // height: 100%;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    padding: 60px 0 30px 0;
    gap: 30px;
    position: relative;
    .backPageItem{
      position: absolute;
      left: 100px;
      top:40px;
      width: 30px;
      height: 30px;
    }
    .circleItem{
      position: absolute;
      right: 100px;
      top:40px;
      width: 50px;
      height: 50px;
    }
    .titleLine{
      color: #000;
      text-align: center;
      font-family: "Times New Roman";
      font-size: 40px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      text-transform: capitalize;
    }
    .chooseBlock{
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 20px;
      .chooseItem{
        cursor: pointer;
        max-width: 400px;
        width: 100%;
        border-radius: 8px;
        background: var(---3, rgba(0, 0, 0, 0.03));   
        .el-radio__label {
          white-space: normal !important;
          word-break: break-word !important;
        }
        .el-radio.is-bordered{
            width: 100%;
            display: flex;
            align-items: center;
            padding:12px 20px;
            border: none;
            height:auto
        }
        .el-radio__label{
          padding-left: 20px !important;
          color: #000;
          font-size: 16px !important;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }
        
        .el-radio__input.is-checked+.el-radio__label{
            color: #feae00;

        }
        .el-radio__input.is-checked .el-radio__inner{
          border-color: #feae00;
          background: #feae00;
        }
        .el-radio__inner:hover {
            border-color: #feae00;
        }
      }
    }
    .btnLine{
          display: flex;
        justify-content: center;
        align-items: center;
        .disBtn{
            display: inline-block;
            background: #E0E0E0;
            color: #fff;
            padding: 12px 40px;
            border-radius: 8px;
            font-size: 16px;
        }
        .chooseBtn{
            cursor: pointer;
            display: inline-block;
            background: #212121;
            color: #fafafa;
            padding: 12px 40px;
            border-radius: 8px;
            font-size: 16px;
        }
        .chooseBtn:hover{
            background: #424242;
        }
        .chooseBtn:active{
            background: #212121;
        }
        

    }
    .LastLine{
        display: flex;
        justify-content: center;
        align-items: flex-end;
        margin-top: -30px;
      .skipBtn{
          cursor: pointer;
          padding: 12px 40px;
            font-size: 16px;
            color: #999;
        }
      }
    .LastLine2{
      flex: 1 1;
      display: flex;
        justify-content: center;
        align-items: flex-end;
        // margin-top: -20px;
        .oneItem{
          color: var(---1, #000);
          text-align: center;
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: 22px; /* 110% */
        }
        .twoItem{
          width: 90%;
          max-width: 900px;
          color: #aaa;
          text-align: center;
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }
    }
}
@media screen and (max-width:767px) { 
  .stepOneRoot{
    width: 100%;
    // height: 100%;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    padding: 20vw 6vw 10vw 6vw;
    gap: 10vw;
    position: relative;
    .backPageItem{
      position: absolute;
      left: 2vw;
      top:3vw;
      width: 4vw;
      height: 4vw;
    }
    .circleItem{
      position: absolute;
      right: 2vw;
      top:3vw;
      width: 8vw;
      height: 8vw;
    }
    .titleLine{
      color: #000;
      text-align: center;
      font-family: "Times New Roman";
      font-size: 6vw;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      text-transform: capitalize;
    }
    .chooseBlock{
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 3vw;
      .chooseItem{
        cursor: pointer;
        max-width: 100%;
        width: 100%;
        border-radius: 8px;
        background: var(---3, rgba(0, 0, 0, 0.03));   
      
        .el-radio.is-bordered{
            width: 100%;
            display: flex;
            align-items: center;
            padding:3vw 4vw;
            border: none;
            height:auto
        }
        .el-radio__label{
          padding-left: 3vw !important;
          color: #000;
          font-size: 3.4vw !important;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }
        
        .el-radio__input.is-checked+.el-radio__label{
            color: #feae00;

        }
        .el-radio__input.is-checked .el-radio__inner{
          border-color: #feae00;
          background: #feae00;
        }
        .el-radio__inner:hover {
            border-color: #feae00;
        }
      }
    }
    .btnLine{
          display: flex;
        justify-content: center;
        align-items: center;
        .disBtn{
            display: inline-block;
            background: #E0E0E0;
            color: #fff;
            padding: 1.2vw 4vw;
            border-radius: 8px;
            font-size: 3.4vw;
        }
        .chooseBtn{
            cursor: pointer;
            display: inline-block;
            background: #212121;
            color: #fafafa;
            padding: 1.2vw 4vw;
            border-radius: 8px;
            font-size: 3.4vw;
        }
        .chooseBtn:hover{
            background: #424242;
        }
        .chooseBtn:active{
            background: #212121;
        }
        

    }
    .LastLine{
        display: flex;
        justify-content: center;
        align-items: flex-end;
        margin-top: -6vw;
      .skipBtn{
          cursor: pointer;
          padding: 1.2vw 4vw;
            font-size: 3.4vw;
            color: #999;
        }
      }
      .LastLine2{
        flex: 1 1;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        // margin-top: -4vw;
        .oneItem{
            color: var(---1, #000);
            text-align: center;
            font-size: 3.4vw;
            font-style: normal;
            font-weight: 400;
            line-height: 1.3; /* 110% */
          }
          .twoItem{
            width: 90%;
            max-width: 900px;
            color: #aaa;
            text-align: center;
            font-size: 3vw;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
          }
    }
}
}


@media screen  and (min-width: 767px) and (max-width: 1200px){
  .stepOneRoot{
    width: 100%;
    // height: 100%;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    padding: 6vw 0 3vw;
    gap: 3vw;
    position: relative;
    .backPageItem{
      position: absolute;
      left: 6vw;
      top:2vw;
      width: 5vw;
      height: 5vw;
    }
    .circleItem{
      position: absolute;
      right: 6vw;
      top:2vw;
      width: 5vw;
      height: 5vw;
    }
    .titleLine{
      color: #000;
      text-align: center;
      font-family: "Times New Roman";
      font-size: 3.2vw;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      text-transform: capitalize;
    }
    .chooseBlock{
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 2vw;
      .chooseItem{
        cursor: pointer;
        max-width: 400px;
        width: 100%;
        border-radius: 8px;
        background: var(---3, rgba(0, 0, 0, 0.03));   
      
        .el-radio.is-bordered{
            width: 100%;
            display: flex;
            align-items: center;
            padding:12px 20px;
            border: none;
            height:auto
        }
        .el-radio__label{
          padding-left: 20px !important;
          color: #000;
          font-size: 16px !important;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }
        
        .el-radio__input.is-checked+.el-radio__label{
            color: #feae00;

        }
        .el-radio__input.is-checked .el-radio__inner{
          border-color: #feae00;
          background: #feae00;
        }
        .el-radio__inner:hover {
            border-color: #feae00;
        }
      }
    }
    .btnLine{
          display: flex;
        justify-content: center;
        align-items: center;
        .disBtn{
            display: inline-block;
            background: #E0E0E0;
            color: #fff;
            padding: 1.2vw 4vw;
            border-radius: 8px;
            font-size: 1.6vw;
        }
        .chooseBtn{
            cursor: pointer;
            display: inline-block;
            background: #212121;
            color: #fafafa;
            padding: 1.2vw 4vw;
            border-radius: 8px;
            font-size: 1.6vw;
        }
        .chooseBtn:hover{
            background: #424242;
        }
        .chooseBtn:active{
            background: #212121;
        }
        

    }
    .LastLine{
        display: flex;
        justify-content: center;
        align-items: flex-end;
        margin-top: -3vw;
      .skipBtn{
          cursor: pointer;
          padding: 1.2vw 4vw;
            font-size: 1.6vw; 
            color: #999;
        }
      }
      .LastLine2{
        flex: 1 1;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        // margin-top: -1vw;
        .oneItem{
          color: var(---1, #000);
          text-align: center;
          font-size: 1.6vw;
          font-style: normal;
          font-weight: 400;
          line-height: 1.3; /* 110% */
        }
        .twoItem{
          width: 90%;
          max-width: 900px;
          color: #aaa;

          text-align: center;
          font-size: 1.2vw;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }
    }
}
}
</style>